import commitMutation from 'relay-commit-mutation-promise';
import { graphql, type Environment } from 'react-relay';
import {
    type FavoritePageInput as Input,
    type followPageMutation$data as Response,
    type followPageMutation as Mutation,
} from './__generated__/followPageMutation.graphql.ts';

const taggedQuery = graphql`
    mutation followPageMutation($input: FavoritePageInput!) {
        favoritePage(input: $input) {
            user {
                favorites(types: [DESIGNER]) {
                    edges {
                        node {
                            serviceId
                            anchor {
                                sourceId
                            }
                        }
                    }
                }
            }
        }
    }
`;

export async function followPage(environment: Environment, input: Input): Promise<Response> {
    return await commitMutation<Mutation>(environment, {
        mutation: taggedQuery,
        variables: { input },
    });
}
